import styles from 'styles/SearchInputWrapper.module.css'

const SearchInputWrapper = ({ children }) => (
    <div className={styles.wrapper}>
        { children }
    </div>
)

export default SearchInputWrapper